import type { PropsWithChildren } from 'react';

import './VendorLeadBillingInfoLayout.scss';

import LogoText from 'src/assets/logo-text.svg?react';
import { VendorLeadBillingInfoLayoutNextButton } from 'src/components/vendors/billing/VendorLeadBillingInfoLayoutNextButton';
import { VendorLeadBillingInfoStepper } from 'src/components/vendors/billing/VendorLeadBillingInfoStepper';

export function VendorLeadBillingInfoLayout({ children }: Readonly<PropsWithChildren>) {
  return (
    <div className="vendor-lead-billing-info-step__layout">
      <div className="vendor-lead-billing-info-step__layout__left" />

      <div className="vendor-lead-billing-info-step__layout__center__header__backdrop" />
      <div className="vendor-lead-billing-info-step__layout__center__header__container">
        <div className="vendor-lead-billing-info-step__layout__center__header">
          <div className="vendor-lead-billing-info-step__layout__center__header__left-buttons">&nbsp;</div>

          <div className="vendor-lead-billing-info-step__layout__center__header__logo">
            <LogoText className="vendor-lead-billing-info-step__layout__center__header__logo-text" />
            <div className="vendor-lead-billing-info-step__layout__center__header__logo-icon" />
          </div>

          <div className="vendor-lead-billing-info-step__layout__center__header__right-buttons">&nbsp;</div>
        </div>

        <div className="vendor-lead-billing-info-step__layout__center__stepper">
          <VendorLeadBillingInfoStepper />
        </div>
      </div>

      <div className="vendor-lead-billing-info-step__layout__center">
        <div className="vendor-lead-billing-info-step__layout__center__content">{children}</div>

        <div className="vendor-lead-billing-info-step__layout__center__footer-actions">
          <VendorLeadBillingInfoLayoutNextButton />
        </div>
      </div>
      <div className="vendor-lead-billing-info-step__layout__right">&nbsp;</div>
    </div>
  );
}
